<template>
  <v-row class="ma-1">
    <v-col md="12" cols="12">
      <v-toolbar class="mb-2" color="primary" dark flat>
        <v-toolbar-title>Používatelia systému</v-toolbar-title>
        <div class="flex-grow-1"></div>
        <v-toolbar-items>
          <v-btn @click="addUser()" text>Pridať</v-btn>
        </v-toolbar-items>
      </v-toolbar>
    </v-col>
    <v-col md="12" cols="12">
      <v-data-table
        :headers="headers"
        :items="users"
        :items-per-page="10"
        class="elevation-1"
        @click:row="editUser($event)"
      >
        <template v-slot:item.IsAdmin="{ item }">
          <v-chip v-if="item.IsAdmin" color="primary">Administrátor</v-chip>
        </template>
      </v-data-table>
    </v-col>
    <user-detail ref="dialogUser" @change="readUsers()"></user-detail>
  </v-row>
</template>
<script>
import UserDetail from "../components/UserDetail.vue"

export default {
  data: () => ({
    headers: [
      { text: "ID", align: "left", sortable: true, value: "ID" },
      { text: "Meno", align: "left", sortable: true, value: "Name" },
      { text: "Email", align: "left", sortable: false, value: "Email" },
      {
        text: "Administrátor",
        align: "left",
        sortable: false,
        value: "IsAdmin"
      }
    ],

    users: []
  }),

  components: {
    UserDetail
  },

  methods: {
    readUsers: async function() {
      try {
        let response = await this.$axios.get("/r/users")
        if (response.status === 200) {
          this.users = response.data
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      }
    },

    addUser: function() {
      this.$refs.dialogUser.show({ id: "" })
    },

    editUser: function(user) {
      this.$refs.dialogUser.show(user)
    }
  },

  mounted: async function() {
    console.log("users mounted")
    await this.$store.dispatch("fetchme", this.$axios)
    await this.readUsers()
  }
}
</script>
